import { getAllHealth, refreshHealth } from "api/health";

const healthCheckApiConfig = {
  refreshHealth,
  getAllHealth
};

export default healthCheckApiConfig;